// ── Flow picker pictograms ────────────────────────────────────────────────────
// SVG inner paths for each pictogram (24×24 viewBox, stroke-based / Lucide style).
// makePictogramUrl() encodes a selected pictogram as a data URL for storage.

export const PICTOGRAMS = [
  { id: 'login',    label: 'Check-In',
    svg: '<path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4"/><polyline points="10 17 15 12 10 7"/><line x1="15" y1="12" x2="3" y2="12"/>' },
  { id: 'logout',   label: 'Check-Out',
    svg: '<path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/>' },
  { id: 'refresh',  label: 'Wiederkehr',
    svg: '<polyline points="23 4 23 10 17 10"/><polyline points="1 20 1 14 7 14"/><path d="M3.51 9a9 9 0 0114.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0020.49 15"/>' },
  { id: 'user',     label: 'Person',
    svg: '<path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"/><circle cx="12" cy="7" r="4"/>' },
  { id: 'users',    label: 'Gruppe',
    svg: '<path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/>' },
  { id: 'badge',    label: 'Ausweis',
    svg: '<rect x="2" y="4" width="20" height="16" rx="2"/><circle cx="8" cy="10" r="2"/><line x1="14" y1="8" x2="18" y2="8"/><line x1="14" y1="12" x2="18" y2="12"/><line x1="8" y1="14" x2="10" y2="14"/>' },
  { id: 'clock',    label: 'Uhrzeit',
    svg: '<circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>' },
  { id: 'building', label: 'Gebäude',
    svg: '<path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>' },
  { id: 'car',      label: 'Fahrzeug',
    svg: '<rect x="1" y="10" width="22" height="10" rx="2"/><path d="M5 10V7a2 2 0 012-2h10a2 2 0 012 2v3"/><circle cx="7" cy="20" r="1"/><circle cx="17" cy="20" r="1"/>' },
  { id: 'package',  label: 'Lieferung',
    svg: '<path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 001 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"/><polyline points="3.27 6.96 12 12.01 20.73 6.96"/><line x1="12" y1="22.08" x2="12" y2="12"/>' },
  { id: 'hardhat',  label: 'Arbeiter',
    svg: '<path d="M2 18h20"/><path d="M4.5 10.5A7.5 7.5 0 0112 3a7.5 7.5 0 017.5 7.5"/><line x1="9" y1="18" x2="9" y2="21"/><line x1="15" y1="18" x2="15" y2="21"/>' },
  { id: 'shield',   label: 'Sicherheit',
    svg: '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>' },
]

export const makePictogramUrl = (svg) =>
  'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="#eeeeed" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">${svg}</svg>`
  )
